var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { BoostPortalSessionHandler } from '../helpers/BoostPortalSessionHandler';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { router } from '../router/BoostPortalRouter';
import { BoostButton } from './common/BoostButton';
import { isSuccessHTTP } from 'boost-api/APIRestClient';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
import { BoostHamburgerMenu } from './common/BoostHamburgerMenu';
let BoostPortalHeader = class BoostPortalHeader extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    constructor() {
        super(...arguments);
        this.viewLoginButton = true;
        this.disabled = false;
        this.isSmallerScreen = false;
        this.hideHeaderInformation = false;
        this.viewHideInfoButton = false;
        this.sessionHandler = new BoostPortalSessionHandler();
    }
    static get is() {
        return 'boost-portal-header';
    }
    get routerOutlet() {
        return this.shadowRoot && this.shadowRoot.getElementById('routerOutlet');
    }
    static get styles() {
        return css `
            .content-header h1 {
                font-weight: 300;
                font-size: 1.5em;
            }

            .content-header {
                margin: 40px;
                display: flex;
                align-items: center;
                z-index: 2;
                justify-content: space-between;
            }

            .content-header a {
                color: var(--portalForeground);
                text-decoration: none;
            }

            #identity-wrapper {
                align-items: center;
                display: flex;
                height: 65px;
            }

            .logo {
                max-height: 65px;
                max-width: 150px;
                background-color: var(--portalSidebarContentBackground);
            }

            .logo-text {
                font-size: 18px;
                text-align: center;
                margin-left: 6px;
                color: var(--boost-font-color-dark);
            }

            .logo-text:hover {
                color: #666666;
            }

            .a {
                fill: none;
                stroke: currentColor;
                stroke-linecap: round;
                stroke-width: 2px;
            }

            .language-toggle {
                position: relative;
                display: inline-block;
                width: 60px;
                height: 34px;
            }

            .language-toggle input {
                opacity: 0;
                width: 0;
                height: 0;
            }

            .slider {
                position: absolute;
                cursor: pointer;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #ccc;
                transition: 0.4s;
                border-radius: 34px;
            }

            .slider::before {
                position: absolute;
                content: '';
                height: 26px;
                width: 26px;
                left: 4px;
                bottom: 4px;
                background-image: url('images/flags/no.svg');
                background-size: cover;
                background-position: center;
                transition: 0.4s;
                border-radius: 50%;
            }

            .en.slider::before {
                transform: translateX(26px);
                background-image: url('images/flags/uk.svg');
            }

            vaadin-checkbox::part(checkbox) {
                display: none;
            }

            .button-toggle-container {
                display: flex;
                flex-direction: row;
                gap: 1rem;
            }

            @media screen and (max-width: 1200px) {
                .content-header {
                    max-width: 100%;
                    margin: 6px;
                    gap: 0px;
                    flex-wrap: nowrap;
                }

                .content-header h1 {
                    margin-left: 10px;
                    font-size: 20px;
                }

                .logo {
                    max-width: 200px;
                }

                #identity-wrapper {
                    width: 75%;
                }

                boost-button {
                    font-size: 14px;
                    width: 24%;
                }

                .language-toggle {
                    width: 52px;
                    height: 28px;
                    margin-left: 2rem;
                }

                .en.slider::before {
                    transform: translatex(12px);
                    width: 24px;
                    height: 24px;
                    bottom: 2px;
                    left: 13px;
                }

                .slider::before {
                    height: 24px;
                    width: 24px;
                    left: 3px;
                    bottom: 2px;
                }
            }
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this._onConnectedCallback();
    }
    /** @override */ render() {
        return html ` <div class="content-header">
            <a
                id="identity-wrapper"
                @click="${() => !this.disabled
            ? window.location.replace(this.centerShort ? this.centerShort : router.baseUrl)
            : ''}"
                >${this.headerLogo ? this.headerLogo : ''}
            </a>
            <div class="button-toggle-container">
                ${this._renderHideInfoButton()}
                ${this.hideHeaderInformation
            ? html ``
            : html `<label class="language-toggle">
                          <vaadin-checkbox @change=${this.onLanguageChange}> </vaadin-checkbox>
                          <span class="slider ${this.currentLanguage}"></span>
                      </label>`}
                ${this.isSmallerScreen ? this._renderHamburgerMenu() : this._renderHeadingButtons()}
            </div>
        </div>`;
    }
    _renderHideInfoButton() {
        if (this.viewHideInfoButton && !this.isSmallerScreen) {
            return html ` <boost-button
                @click="${() => this._handleButtonClick()}"
                type="toggle-info"
                name="${this.hideHeaderInformation
                ? this.boostTranslate('show-header')
                : this.boostTranslate('hide-header')}"
                id="sign"
            ></boost-button>`;
        }
    }
    _handleButtonClick() {
        this.dispatchEvent(new CustomEvent('toggle-hide-info', {
            bubbles: true,
            composed: true,
            detail: {
                hideHeaderInformation: !this.hideHeaderInformation,
            },
        }));
    }
    _onConnectedCallback() {
        const media = window.matchMedia('(max-width: 1024px)');
        this.isSmallerScreen = media.matches;
        media.addEventListener('change', (event) => {
            this.isSmallerScreen = event.matches;
        });
    }
    _renderHamburgerMenu() {
        return html `
            <boost-hamburger-menu .menuItems="${this._getHamburgerMenuItems()}"></boost-hamburger-menu>
        `;
    }
    _getHamburgerMenuItems() {
        const items = [];
        if (this.session) {
            items.push({
                title: this.boostTranslate('my-profile'),
                callback: () => this._navigateToProfile(),
                icon: 'vaadin:user',
            }, {
                title: this.boostTranslate('log-out-button'),
                callback: () => this._logOut(),
                icon: 'vaadin:sign-out',
            });
        }
        if (!this.session && this.viewLoginButton) {
            items.push({
                title: this.boostTranslate('log-in-button'),
                callback: () => this._navigateToLogin(),
                icon: 'vaadin:sign-in',
            });
        }
        if (this.isSmallerScreen && this.showCollapseForClassesMenu) {
            items.push({
                title: this.hideHeaderInformation
                    ? this.boostTranslate('show-header')
                    : this.boostTranslate('hide-header'),
                callback: () => this._handleButtonClick(),
                icon: 'vaadin:compress',
            });
        }
        return items;
    }
    _getHeaderLogoPromise(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const logoObj = new Image();
                logoObj.onload = () => resolve(logoObj);
                logoObj.onerror = reject;
                logoObj.classList.add('logo');
                logoObj.src = url;
            });
        });
    }
    _setHeaderLogo() {
        setTimeout(() => {
            if (!this.logo) {
                this.headerLogo = this._renderCenterName();
                return;
            }
            const { width, height } = this.logo;
            if (width < 20 || height < 20) {
                this.headerLogo = this._renderCenterName();
                return;
            }
            this.headerLogo = html `<div
                @mouseenter="${() => this._logoHover()}"
                @mouseleave="${() => this._setHeaderLogo()}"
            >
                ${this.logo}
            </div>`;
        }, 300);
    }
    _logoHover() {
        if (this.disabled) {
            return;
        }
        this.headerLogo = html `&lt; <span class="logo-text">${this.boostTranslate('go-back')}</span>`;
    }
    _renderCenterName() {
        return html `<h1 @mouseenter="${() => this._logoHover()}" @mouseleave="${() => this._setHeaderLogo()}">
            ${this.center ? html ` ${this.center.title} ` : html ` Portal `}
        </h1>`;
    }
    _navigateToLogin() {
        window.history.pushState(null, document.title, router.baseUrl + this.centerShort + '/login');
        window.dispatchEvent(new PopStateEvent('popstate'));
    }
    _navigateToProfile() {
        window.history.pushState(null, document.title, router.baseUrl + this.centerShort + '/profile');
        window.dispatchEvent(new PopStateEvent('popstate'));
    }
    _logOut() {
        this.sessionHandler.deleteLoginSession();
        window.location.replace(router.baseUrl + this.centerShort + '/login');
    }
    _renderHeadingButtons() {
        return html `${this.session
            ? html `<div style="display: flex;">
                  <boost-button
                      style="margin-right: 10px;"
                      type="header-button"
                      name="${this.boostTranslate('my-profile')}"
                      @click="${() => this._navigateToProfile()}"
                  ></boost-button>
                  <boost-button
                      type="logout"
                      name="${this.boostTranslate('log-out-button')}"
                      @click="${() => this._logOut()}"
                  ></boost-button>
              </div>`
            : this.viewLoginButton
                ? html `<boost-button
                    type="header-button"
                    name="${this.boostTranslate('log-in-button')}"
                    @click="${() => this._navigateToLogin()}"
                ></boost-button>`
                : nothing}`;
    }
    _loadHeaderLogo() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.center || !this.serviceUrl) {
                return;
            }
            const logoResult = yield this._getHeaderLogoPromise(this.serviceUrl +
                '/rest/document/logo/' +
                this.center.id +
                (this.selectedDepartmentId ? '/' + this.selectedDepartmentId : ''));
            if (isSuccessHTTP(logoResult)) {
                this.logo = logoResult;
            }
            this._setHeaderLogo();
        });
    }
    /** @override */ updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'serviceUrl':
                case 'center':
                case 'selectedDepartmentId':
                    this._loadHeaderLogo();
                    break;
            }
        });
        super.updated(changedProperties);
    }
};
BoostPortalHeader._deps = [BoostButton, BoostHamburgerMenu];
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    state(),
    __metadata("design:type", String)
], BoostPortalHeader.prototype, "centerShort", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('session')),
    state(),
    __metadata("design:type", String)
], BoostPortalHeader.prototype, "session", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('serviceUrl')),
    state(),
    __metadata("design:type", String)
], BoostPortalHeader.prototype, "serviceUrl", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('center')),
    state(),
    __metadata("design:type", Object)
], BoostPortalHeader.prototype, "center", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedDepartmentId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalHeader.prototype, "selectedDepartmentId", void 0);
__decorate([
    property({ type: Boolean, attribute: 'view-login-button' }),
    __metadata("design:type", Boolean)
], BoostPortalHeader.prototype, "viewLoginButton", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('showCollapseForClassesMenu')),
    state(),
    __metadata("design:type", Boolean)
], BoostPortalHeader.prototype, "showCollapseForClassesMenu", void 0);
__decorate([
    state(),
    __metadata("design:type", HTMLImageElement)
], BoostPortalHeader.prototype, "logo", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalHeader.prototype, "headerLogo", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Boolean)
], BoostPortalHeader.prototype, "disabled", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalHeader.prototype, "isSmallerScreen", void 0);
__decorate([
    property({ type: Boolean, attribute: 'hide-header-information' }),
    __metadata("design:type", Boolean)
], BoostPortalHeader.prototype, "hideHeaderInformation", void 0);
__decorate([
    property({ type: Boolean, attribute: 'view-hide-info-button' }),
    __metadata("design:type", Boolean)
], BoostPortalHeader.prototype, "viewHideInfoButton", void 0);
BoostPortalHeader = __decorate([
    customElement(BoostPortalHeader.is)
], BoostPortalHeader);
export { BoostPortalHeader };
